import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'src/shared/components/Input';

interface Props {
    questionId: string;
    questionText?: string;
    response: string;
    handleResponseChange: (questionId: string, value: string) => void;
}

export const ReviewInputFullText: React.FC<Props> = ({
    questionId,
    questionText,
    response,
    handleResponseChange,
}) => {
    const { t } = useTranslation();

    return (
        <Input
            type="textarea"
            fieldId={questionId}
            label={t(questionText as string) || ''}
            value={response}
            onChange={value => handleResponseChange(questionId, value)}
        />
    );
};
